import { ComponentType } from '../../registries/types/propTypes';
import { CMSDataType } from '../../../utils/common';
import { HeroBannerCarousalProps } from '../../../components/HeroBannerCarousal/types/propsType';

const transformerHeroBannerCarousal = (data: CMSDataType): HeroBannerCarousalProps => {
  const heroBannerCarousalData = Array.isArray(data?.product_carousal_banner)
    ? data?.product_carousal_banner[0]
    : data?.product_carousal_banner;
  const title = heroBannerCarousalData?.display_title;
  const sub_title = heroBannerCarousalData?.sub_title;
  const ctaLink = {
    text: heroBannerCarousalData?.link?.text,
    url: heroBannerCarousalData?.link?.url,
    target: heroBannerCarousalData?.link?.target,
  };
  const overlayGradient = heroBannerCarousalData?.overlay_gradient;
  const linearGradient = heroBannerCarousalData?.linear_gradient?.color;
  const image = heroBannerCarousalData?.image?.images?.map((item: CMSDataType) => {
    const image = {
      url: item.image.url,
      altText: item.alt_text,
      viewport: item?.viewport,
    };
    return image;
  });
  const products = heroBannerCarousalData?.products?.map((p: CMSDataType) => ({
    productId: p.product_id,
    isBundle: p.is_bundle,
  }));
  const aprContainerKey = heroBannerCarousalData?.apr_container_key;
  const pageName = heroBannerCarousalData?.page_name;
  return {
    componentType: ComponentType.product_carousal_banner,
    subTitle: sub_title,
    title: title,
    ctaLink: ctaLink,
    overlayGradient,
    linearGradient,
    image,
    products: products ?? [],
    aprContainerKey: aprContainerKey,
    pageName: pageName,
  };
};
export default transformerHeroBannerCarousal;
